import styled, { css } from 'styled-components';
import { FunctionColor, Spacer, TextFontSize } from '@lux/tokens';
import { ColorMode } from '@lux/core';

export const CampaignCardMiniWrapper = styled.a<{ bgTransparent: boolean }>`
    position: relative;
    transition: all 0.33s ease-in-out;

    background: ${({ bgTransparent }) => (bgTransparent ? 'transparent' : '#fff')};
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &:hover,
    &:focus-within {
        .delivery-label {
            visibility: hidden;
            opacity: 0;
        }
    }
`;

export const ImageWrapper = styled.div<{ withLogo: boolean }>`
    position: relative;
    width: 100%;
    aspect-ratio: 1/1;

    ${({ withLogo }) =>
        !withLogo &&
        css`
            &::before {
                content: ' ';
                background: linear-gradient(
                    180deg,
                    rgba(0, 0, 0, 0.03) 31.74%,
                    rgba(0, 0, 0, 0.3) 90%
                );
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
            }
        `}
`;

export const CampaignImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const ContentWrapper = styled.div<{ isPlusVariant?: boolean }>`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding-block-start: ${Spacer.XS};
    padding-inline-start: ${Spacer.XS};
    padding-block-end: ${Spacer.S};
    background-color: ${({ isPlusVariant, theme }) => {
        if (isPlusVariant) {
            return theme.colorMode === ColorMode.DARK ? '#1a1a1a' : '#000';
        }

        return 'transparent';
    }};
`;

export const SpacerXS = styled.div`
    height: ${Spacer.XS};
`;

export const SpacerS = styled.div`
    height: ${Spacer.S};
`;

export const CampaignTitle = styled.div<{ isPlusVariant?: boolean }>`
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    font-size: ${TextFontSize.XS};
    line-height: 1.4;
    font-weight: 700;
    flex: 1 1 auto;
    color: ${({ isPlusVariant }) => (isPlusVariant ? '#ffffff' : FunctionColor.function100)};
    text-align: start;
    overflow: hidden;
`;

export const Title = styled.div`
    position: absolute;
    width: 100%;
    text-align: center;
    color: ${FunctionColor.function0};
    font-weight: 700;
    z-index: 2;
    font-size: 18px;
    padding: 20px 8px 0;
    bottom: 60px;
`;
